import { render, staticRenderFns } from "./RefIdEdit.vue?vue&type=template&id=5e4702f5&"
import script from "./RefIdEdit.vue?vue&type=script&lang=js&"
export * from "./RefIdEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports